import { Base, Uploadable, ScheduleDate, CompanyRef } from '@akiba/models_bimbo';

export class firstDiscount extends Base {
    weekNumber: number;
    dateFirstDiscount: Date;

    constructor(data: any | null = null) {

        super();
        this.weekNumber = 0;
        this.dateFirstDiscount = new Date();
        this.load(data);

    }
}

export class ShareSavingParameters extends Base {
    minAmount: number;
    maxDays: number;
    firstDiscount: firstDiscount;
    fileUploaded: Uploadable;
    factor: number;
    registrationDates: Array<ScheduleDate>;
    includedCompanies: Array<CompanyRef>;
    wageTypes: Array<string>;
    contractTypes: Array<string>;

    constructor(data: any | null = null) {

        super();
        this.wageTypes = new Array<string>();
        this.contractTypes = new Array<string>();
        this.minAmount = 0.0;
        this.maxDays = 0;
        this.fileUploaded = new Uploadable();
        this.registrationDates = new Array<ScheduleDate>();
        this.includedCompanies = new Array<CompanyRef>();
        this.firstDiscount = new firstDiscount();

        this.load(data);

    }

    toAny(): any {
        const superTA = super.toAny();
        return superTA;
    }
}

export class ShareSaving extends Base {

    parametersID: string;
    title: string;
    type: number;
    savingParameter: ShareSavingParameters;
    active: boolean;

    constructor(data: any | null = null) {
        super();
        this.parametersID = '';
        this.title = '';
        this.type = 7;
        this.savingParameter = new ShareSavingParameters();
        this.active = true;
        this.load(data);

    }

    toAny(): any {
        const superTA = super.toAny();
        return superTA;
    }

}
